import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import Landing from './pages/Landing';
import Popular from './pages/Popular';
import Random from './pages/Random';
import Selected from './pages/Selected';
import Ingame from './pages/Ingame';
import Credits from './pages/Credits';
import Win from './pages/Win';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#fdf6ec] flex items-center justify-center px-4">
      <div className="w-full max-w-sm text-center">
        <span className="bg-[#ff6b35] text-white text-xs font-black tracking-[3px] uppercase px-3 py-1 rounded">
          FILMQUEST
        </span>
        <div className="text-8xl font-black text-[#1a1a1a] mt-6 mb-2">404</div>
        <p className="text-sm text-[#888] mb-6">This page doesn't exist.</p>
        <button
          onClick={() => navigate('/')}
          className="bg-[#ff6b35] text-white font-black text-base py-3 px-6 rounded-lg border-[3px] border-[#1a1a1a] shadow-[4px_4px_0_#1a1a1a] hover:shadow-[2px_2px_0_#1a1a1a] transition-shadow"
        >
          Go Home
        </button>
      </div>
    </div>
  );
};

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/ingame" element={<Ingame />} />
        <Route path="/popular" element={<Popular />} />
        <Route path="/random" element={<Random />} />
        <Route path="/selected" element={<Selected />} />
        <Route path="/credits" element={<Credits />} />
        <Route path="/win" element={<Win />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
